import styled from 'styled-components'

export const Container = styled.main`
  min-height: 100%;
  background: #f3f3f3;
  position: relative;

  display: flex;
  flex-direction: column;
`

export const Content = styled.div`
  flex: 1;

  display: flex;
`

export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
`

export const StyledSearch = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
`

export const Article = styled.article`
  width: 100%;
  min-height: 50px;

  background: #d6dbdf;
  font-size: 14px;

  border-radius: 5px;
  padding: 0 10px;

  display: flex;
  align-items: center;

  cursor: pointer;

  opacity: 0.5;

  &:hover {
    opacity: 1;
  }

  p {
    all: unset;
  }
`

export const Step = styled.div`
  background-color: ${({ selected }) => (selected ? '#0d6efd' : '#d6dbdf')};
  padding: 15px;
  border-radius: 10px;
  transition: background-color 0.5s;

  display: flex;
  align-items: center;
  gap: 10px;

  h3 {
    all: unset;
    color: ${({ selected }) => (selected ? 'white' : 'black')};
    font-size: 16px;
    font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  }

  svg {
    fill: ${({ selected }) => (selected ? 'white' : 'black')};
  }
`

export const Form = styled.div`
  flex: 1;
`

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  gap: 10px;

  position: fixed;
  bottom: 0;
  right: 0;
`

export const NextButton = styled.button`
  all: initial;

  background: #0d6efd;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  transition: transform 0.7s;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #0d6efd;
    transform: scale(1.1, 1.1);
  }
`

export const Center = styled.div`
  width: 100%;
  height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    font-size: 20px;
    margin-top: 10px;
  }
`

export const ContainerComponent = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 20px;

  display: grid;
  grid-template-rows: 80% 20%;

  h4 {
    margin-bottom: 50px;
  }
`

export const ContentComponent = styled.div``

export const FooterComponent = styled.footer`
  width: 100%;
  height: 60px;

  display: flex;
  align-items: flex-end;
`
